// Browser Supabase client for the admin SPA.
//
// Uses the PUBLIC anon/publishable key only — the service-role key never reaches
// the browser (that was the whole point of Option C). Authorization for every
// admin_* edge function is decided server-side by `requireAdmin` (verify_jwt at
// the gateway + an is_admin lookup), so this client only needs to (a) carry the
// signed-in user's session JWT and (b) complete the OAuth PKCE exchange.
import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    "Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY — set them in the build env.",
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Complete the OAuth code exchange on page load (the SPA replaces the old
    // /auth/callback server route).
    detectSessionInUrl: true,
    flowType: "pkce",
  },
});
